import { positiveWords } from './positiveWords';
import { stoicQuotes } from './stoicQuotes';
import { scienceFacts } from './scienceFacts';
import { philosophyQuotes } from './philosophyQuotes';

export const inspirationalContent = {
    positiveWords,
    stoicQuotes,
    scienceFacts,
    philosophyQuotes
};
